import React, { useLayoutEffect, useRef } from 'react';
import { DropdownWrapper } from '../../styles/dropdown.style';
import {
    CategoryOptions,
    MenuCategoryContainer,
    MenuItemsWrapper,
    MobileDropdownContents,
    NavButtonContainer,
} from '../../styles/mobileDropdown.style';
import { NAV_ITEMS, NAV_TAGS } from '../../constants';
import NavigationButtons from '../NavigationButtons';
import PropTypes from 'prop-types';
import MobileSubMenu from '../MobileSubMenu';
import NavButton from '../NavButton';
import { navigate } from 'gatsby';
import useClickOutside from '../../../../hooks/useClickOutside';
import gsap from 'gsap';

const MobileDropdown = ({
    isHomePage,
    getStartedCtaLink,
    activeMenu,
    setActiveMenu,
    dropdownCategories,
    menuItems,
    activeDropdownCategory,
    setActiveDropdownCategory,
    setIsMobileDropdownActive,
    openModal,
    menuButtonRef,
    onCloseMobileMenu,
}) => {
    const dropdownContainerRef = useRef(null);
    const navItemsRef = useRef(null);
    const navButtonRef = useRef(null);

    useClickOutside({
        handler: onCloseMobileMenu,
        refs: [dropdownCategories, navItemsRef, navButtonRef],
        ignoreRefs: [menuButtonRef],
    });

    const handleMenuClick = (type) => {
        if (type === NAV_ITEMS.PRICING) {
            navigate('/#pricing');
            setIsMobileDropdownActive(false);
            return;
        }

        if (type === activeMenu) {
            setActiveMenu('');
        } else {
            setActiveMenu(type);
        }
    };

    const handleSubMenuClick = (type) => {
        if (activeDropdownCategory === type) {
            setActiveDropdownCategory('');
        } else {
            setActiveDropdownCategory(type);
        }
    };

    const onSecondaryButtonClick = () => {
        if (isHomePage) {
            navigate('/#contact');
        } else {
            openModal('contact');
        }
        onCloseMobileMenu();
    };

    const isActive = (type) => activeDropdownCategory === type;

    useLayoutEffect(() => {
        if (navItemsRef.current) {
            gsap.fromTo(
                navItemsRef.current,
                {
                    opacity: 0,
                    x: -20,
                },
                {
                    opacity: 1,
                    x: 0,
                    duration: 0.4,
                    ease: 'power1.inOut',
                }
            );
        }

        if (navButtonRef.current) {
            gsap.fromTo(
                navButtonRef.current,
                {
                    opacity: 0,
                    x: -20,
                },
                {
                    delay: 0.2,
                    opacity: 1,
                    x: 0,
                    duration: 0.4,
                    ease: 'power1.inOut',
                }
            );
        }
    }, []);

    return (
        <DropdownWrapper>
            <MobileDropdownContents ref={dropdownContainerRef}>
                <MenuItemsWrapper ref={navItemsRef}>
                    {NAV_TAGS.map((item) => (
                        <>
                            <NavButton
                                key={item.label + item.id}
                                isActive={activeMenu === item.label}
                                onClick={() => handleMenuClick(item.label)}
                                data={item}
                            />
                            {
                                <MenuCategoryContainer>
                                    {activeMenu === item.label && dropdownCategories && (
                                        <CategoryOptions>
                                            {Object.entries(dropdownCategories)?.map(
                                                ([_, category]) => (
                                                    <>
                                                        <NavButton
                                                            key={category.label + category.id}
                                                            onClick={() =>
                                                                handleSubMenuClick(category.label)
                                                            }
                                                            data={category}
                                                            isActive={isActive(category.label)}
                                                        />

                                                        <MobileSubMenu
                                                            active={isActive(category.label)}
                                                            menuItems={menuItems}
                                                            activeDropdownCategory={
                                                                activeDropdownCategory
                                                            }
                                                        />
                                                    </>
                                                )
                                            )}
                                        </CategoryOptions>
                                    )}
                                </MenuCategoryContainer>
                            }
                        </>
                    ))}
                </MenuItemsWrapper>
                <NavButtonContainer ref={navButtonRef}>
                    <NavigationButtons
                        onSecondaryButtonClick={onSecondaryButtonClick}
                        getStartedCtaLink={getStartedCtaLink}
                    />
                </NavButtonContainer>
            </MobileDropdownContents>
        </DropdownWrapper>
    );
};

MobileDropdown.propTypes = {
    isHomePage: PropTypes.bool,
    getStartedCtaLink: PropTypes.string,
    activeMenu: PropTypes.string,
    setActiveMenu: PropTypes.func,
    activeDropdownCategory: PropTypes.string,
    setActiveDropdownCategory: PropTypes.func,
    dropdownCategories: PropTypes.array,
    menuItems: PropTypes.array,
    setIsMobileDropdownActive: PropTypes.func,
    openModal: PropTypes.func,
    menuButtonRef: PropTypes.element,
    onCloseMobileMenu: PropTypes.func,
};

export default MobileDropdown;
